// The items retrieved carry the readings of a group of series, such as the
// speed of each DPI category, in a list of its own inside each sample, while
// the charts draw a lane per series: the group is turned into the fields of
// the chart, and each item into a value per field.

// The fields of a group, taken from the first item that carries it: an item
// with no reading of the group leaves it out, so the search goes on with the
// rest of them.
export const getFieldsOf = (groupName) => (items) => {
  const carrier = items.find((item) => groupName in item);

  return carrier === undefined
    ? []
    : carrier[groupName].map(({ name }) => ({ name, label: name }));
};

// The readings of a group as one value per field, kept at the time of each
// sample: what a chart of a lane per series is given as its items.
export const getFieldsLanes = (groupName, valueName) => (items) =>
  items.map(({ time, ...content }) =>
    Object.fromEntries([
      ["time", time],
      ...(content[groupName] || []).map(({ name, ...values }) => [
        name,
        values[valueName],
      ]),
    ])
  );
